import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";

export const EmployeeNameContainer = styled(Grid)({
  "&:hover": {
    cursor: "pointer",
  },
});
